
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function ServicesPage() {
  const services = [
    {
      id: 1,
      title: 'AI Clone Service',
      description: 'Create your digital twin that works 24/7 to engage prospects, qualify leads, and provide personalized responses to potential clients.',
      image: 'https://public.readdy.ai/ai/img_res/c9fe7d32c6a6218013451a2fe0fc8e94.jpg',
      heroImage: 'https://readdy.ai/api/search-image?query=Digital%20twin%20AI%20avatar%20of%20professional%20real%20estate%20agent%20in%20modern%20office%2C%20holographic%20projection%20technology%2C%20futuristic%20interface%20displays%2C%20clean%20professional%20environment%2C%20blue%20technology%20lighting&width=600&height=400&seq=21&orientation=landscape',
      features: ['24/7 Lead Engagement', 'Voice & Text Responses', 'Personalized Interactions', 'Multi-language Support', 'CRM Integration', 'Performance Analytics'],
      price: 'Starting at $299/month',
      link: '/services/ai-clone'
    },
    {
      id: 2,
      title: 'AI Chatbots',
      description: 'Intelligent chatbots that handle inquiries, schedule viewings, qualify leads, and provide instant responses to website visitors.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20chatbot%20interface%20on%20smartphone%20and%20laptop%20screens%20showing%20real%20estate%20conversation%2C%20clean%20UI%20design%2C%20property%20listings%20visible%2C%20professional%20blue%20theme%2C%20minimalist%20background%2C%20chat%20bubbles&width=500&height=350&seq=22&orientation=landscape',
      heroImage: 'https://readdy.ai/api/search-image?query=AI%20chatbot%20conversation%20interface%20with%20real%20estate%20client%2C%20modern%20smartphone%20displaying%20property%20chat%2C%20professional%20office%20desk%20setup%2C%20clean%20technology%20design%2C%20blue%20accent%20colors&width=600&height=400&seq=23&orientation=landscape',
      features: ['Instant Response', 'Lead Qualification', 'Appointment Scheduling', 'CRM Integration', 'Multi-platform Support', 'Custom Training'],
      price: 'Starting at $199/month',
      link: '/ai-tools/chatbots'
    },
    {
      id: 3,
      title: 'Lead Generation AI',
      description: 'Advanced AI algorithms that identify, target, and qualify high-quality leads from multiple sources automatically.',
      image: 'https://readdy.ai/api/search-image?query=AI%20lead%20generation%20dashboard%20showing%20prospect%20analytics%2C%20data%20visualization%20charts%2C%20real%20estate%20leads%20pipeline%2C%20modern%20interface%20design%2C%20professional%20blue%20color%20scheme%2C%20graphs%20and%20metrics&width=500&height=350&seq=24&orientation=landscape',
      heroImage: 'https://readdy.ai/api/search-image?query=Advanced%20analytics%20dashboard%20with%20real%20estate%20lead%20generation%20data%2C%20multiple%20screens%20showing%20prospect%20information%2C%20modern%20office%20environment%2C%20professional%20data%20visualization%2C%20blue%20technology%20theme&width=600&height=400&seq=25&orientation=landscape',
      features: ['Automated Lead Scoring', 'Multi-source Integration', 'Predictive Analytics', 'Real-time Notifications', 'Lead Nurturing', 'ROI Tracking'],
      price: 'Starting at $399/month',
      link: '/services/lead-generation'
    },
    {
      id: 4,
      title: 'Listing Automation',
      description: 'Automatically create compelling property listings with AI-generated descriptions, optimal pricing, and market positioning.',
      image: 'https://readdy.ai/api/search-image?query=Automated%20property%20listing%20creation%20interface%2C%20AI-generated%20property%20descriptions%2C%20multiple%20listing%20platforms%2C%20professional%20real%20estate%20software%20dashboard%2C%20modern%20design%2C%20property%20photos&width=500&height=350&seq=26&orientation=landscape',
      heroImage: 'https://readdy.ai/api/search-image?query=Real%20estate%20listing%20automation%20software%20on%20computer%20screen%2C%20property%20photos%20being%20processed%2C%20AI%20writing%20descriptions%2C%20modern%20office%20workspace%2C%20professional%20technology%20setup&width=600&height=400&seq=27&orientation=landscape',
      features: ['Auto Description Generation', 'Price Optimization', 'Multi-platform Publishing', 'SEO Optimization', 'Photo Enhancement', 'Market Analysis'],
      price: 'Starting at $249/month',
      link: '/services/listing-automation'
    },
    {
      id: 5,
      title: 'Market Analytics',
      description: 'Get real-time market insights, price predictions, and investment opportunities powered by advanced AI analytics.',
      image: 'https://readdy.ai/api/search-image?query=Real%20estate%20market%20analytics%20dashboard%20with%20charts%20and%20graphs%2C%20property%20value%20trends%2C%20market%20predictions%2C%20professional%20data%20visualization%2C%20blue%20and%20white%20interface%2C%20financial%20charts&width=500&height=350&seq=28&orientation=landscape',
      heroImage: 'https://readdy.ai/api/search-image?query=Advanced%20market%20analytics%20workspace%20with%20multiple%20monitors%20showing%20real%20estate%20data%2C%20price%20trend%20graphs%2C%20investment%20analysis%20charts%2C%20modern%20office%20environment%2C%20professional%20setup&width=600&height=400&seq=29&orientation=landscape',
      features: ['Price Predictions', 'Market Trends', 'Investment Analysis', 'Comparative Analysis', 'Custom Reports', 'API Integration'],
      price: 'Starting at $349/month',
      link: '/services/market-analytics'
    },
    {
      id: 6,
      title: 'AI Property Staging',
      description: 'Transform empty properties with AI-generated furniture and decor to help buyers visualize their future home.',
      image: 'https://readdy.ai/api/search-image?query=Before%20and%20after%20property%20staging%20comparison%2C%20empty%20room%20transformed%20with%20AI-generated%20modern%20furniture%20and%20decor%2C%20split%20screen%20view%2C%20professional%20interior%20design%2C%20bright%20natural%20lighting&width=500&height=350&seq=30&orientation=landscape',
      heroImage: 'https://readdy.ai/api/search-image?query=AI%20property%20staging%20software%20interface%20showing%20room%20transformation%2C%20before%20and%20after%20views%2C%20modern%20furniture%20placement%2C%20professional%20interior%20design%20tools%2C%20clean%20workspace%20setup&width=600&height=400&seq=31&orientation=landscape',
      features: ['Virtual Furniture', 'Style Customization', 'Quick Turnaround', 'Cost Effective', 'Multiple Styles', 'High-Quality Renders'],
      price: 'Starting at $149/month',
      link: '/services/ai-staging'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section with Background Image */}
      <section 
        className="py-32 bg-gradient-to-br from-blue-600 to-blue-800 text-white relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(37, 99, 235, 0.9), rgba(29, 78, 216, 0.9)), url('https://readdy.ai/api/search-image?query=Modern%20real%20estate%20office%20with%20AI%20technology%20displays%2C%20professional%20agents%20working%20with%20digital%20interfaces%2C%20futuristic%20workspace%20environment%2C%20clean%20contemporary%20design%2C%20blue%20technology%20lighting&width=1200&height=600&seq=32&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">
              AI-Powered Services for Real Estate Success
            </h1>
            <p className="text-xl mb-8 leading-relaxed">
              Transform your real estate business with our comprehensive suite of AI tools designed to automate, optimize, and accelerate your success in today's competitive market.
            </p>
            <Link to="/demo">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100">
                <i className="ri-play-circle-fill mr-2"></i>
                Try Free Demo
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Complete AI Solutions for Real Estate Professionals
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Each service is designed to integrate seamlessly with your existing workflow while providing powerful automation and insights.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-72 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-2">
                      <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                    </div>
                  </div>
                </div>
                
                <div className="p-8">
                  <p className="text-gray-600 mb-6 leading-relaxed text-lg">{service.description}</p>
                  
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {service.features.map((feature, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        <span className="text-gray-700 text-sm font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-blue-600">{service.price}</div>
                    <Link to={service.link}>
                      <Button className="bg-blue-600 hover:bg-blue-700">
                        Learn More
                        <i className="ri-arrow-right-line ml-2"></i>
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Showcase */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why Choose Our AI Services?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our AI solutions are built specifically for real estate professionals, with features that address your unique challenges.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Easy Integration',
                description: 'Seamlessly connects with your existing CRM and tools',
                image: 'https://readdy.ai/api/search-image?query=Software%20integration%20dashboard%20showing%20connected%20real%20estate%20tools%2C%20CRM%20systems%20linked%20together%2C%20modern%20interface%20design%2C%20professional%20technology%20setup%2C%20clean%20workspace&width=300&height=200&seq=33&orientation=landscape'
              },
              {
                title: '24/7 Support',
                description: 'Round-the-clock assistance from our expert team',
                image: 'https://readdy.ai/api/search-image?query=Customer%20support%20team%20working%20at%20modern%20help%20desk%2C%20professional%20agents%20assisting%20clients%2C%2024%2F7%20support%20center%2C%20clean%20office%20environment%2C%20technology%20displays&width=300&height=200&seq=34&orientation=landscape'
              },
              {
                title: 'Proven Results',
                description: 'Increase leads by 300% and close deals 50% faster',
                image: 'https://readdy.ai/api/search-image?query=Business%20growth%20charts%20and%20success%20metrics%20on%20computer%20screens%2C%20real%20estate%20performance%20analytics%2C%20upward%20trending%20graphs%2C%20professional%20office%20setting%2C%20data%20visualization&width=300&height=200&seq=35&orientation=landscape'
              },
              {
                title: 'Custom Training',
                description: 'Personalized onboarding and ongoing education',
                image: 'https://readdy.ai/api/search-image?query=Professional%20training%20session%20for%20real%20estate%20technology%2C%20instructor%20teaching%20AI%20tools%2C%20modern%20classroom%20setting%2C%20interactive%20learning%20environment%2C%20professional%20development&width=300&height=200&seq=36&orientation=landscape'
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-40 object-cover rounded-xl mb-4"
                />
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Transform Your Real Estate Business?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join hundreds of successful agents who are already using our AI services to generate more leads, close more deals, and grow their business exponentially.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100">
                <i className="ri-phone-fill mr-2"></i>
                Schedule Consultation
              </Button>
            </Link>
            <Link to="/pricing">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-600">
                <i className="ri-price-tag-3-line mr-2"></i>
                View Pricing
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
